import locale from "localization";
import Validation from "utils/validation.utils";

export const initialState = (state = {}) => {
  const {
    stationCode = { value: "" },
    stationName = { value: "" },
    businessName = { value: "" },
    customerCode = { value: "" },
    stationType = { value: "" },
    island = { value: "" },
    province = { value: "" },
    stationLocation = { value: "" },
    validCoordinates = { value: false },
  } = state;

  return {
    stationCode: {
      name: "stationCode",
      required: true,
      validations: [
        Validation.required(),
        Validation.maxlength(4),
        Validation.minlength(4),
        Validation.numeric(),
        Validation.rangeValue(1000, 9999),
      ],
      label: locale.stationCode,
      placeholder: "9999",
      horizontal: true,
      ...stationCode,
    },
    stationName: {
      name: "stationName",
      required: true,
      validations: [Validation.required(), Validation.minlength(5), Validation.maxlength(100)],
      label: locale.stationName,
      placeholder: "SEAOIL MANILA PANDACAN",
      horizontal: true,
      ...stationName,
    },
    businessName: {
      name: "businessName",
      required: true,
      validations: [Validation.required(), Validation.minlength(5), Validation.maxlength(100)],
      label: locale.customerName,
      placeholder: "SERV CENTRAL, INC.",
      horizontal: true,
      ...businessName,
    },
    customerCode: {
      name: "customerCode",
      required: true,
      validations: [
        Validation.required(),
        Validation.minlength(4),
        Validation.maxlength(5),
        Validation.numeric(),
      ],
      label: locale.customerCode,
      placeholder: "0000",
      horizontal: true,
      ...customerCode,
    },
    stationType: {
      name: "stationType",
      required: true,
      validations: [Validation.required()],
      label: locale.stationType,
      horizontal: true,
      ...stationType,
    },
    island: {
      name: "island",
      required: true,
      validations: [Validation.required()],
      label: locale.island,
      horizontal: true,
      ...island,
    },
    province: {
      name: "province",
      required: true,
      validations: [Validation.required()],
      label: locale.province,
      horizontal: true,
      ...province,
    },
    validCoordinates: {
      name: "validCoordinates",
      ...validCoordinates,
    },
    stationLocation: {
      name: "stationLocation",
      required: true,
      validations: [
        Validation.required({ noMessage: true }),
        Validation.minlength(5),
        Validation.maxlength(100),
      ],
      placeholder: "Longitude / Latitude",
      ...stationLocation,
    },
  };
};
